export const ValidationMessagesTexts = {
  CREATE_GENERATE_REPORT: {
    REPORT_TYPE_REQUIRED: 'Report Type is required.',
    PROJECT_ID_REQUIRED: 'Site or Project Number is required',
    STATE_REQUIRED: 'State is required.',
    CLIENT_REQUIRED: 'Client Name is required.',
    LOCATION_REQUIRED: 'Site or Project Number is required',
    REPORT_NAME_REQUIRED: 'Report Name/Title is required.',
    REFERENCE_REPORT_MONTH_REQUIRED: 'Reference Report Month is required.',
    REPORT_MONTH_REQUIRED: 'Report Month is required.',
    MISSING_FILE_ID_OR_REFERENCE_PATH: 'Missing file ID or reference path. Please re-select the reference document.'
  },
  TOASTER: {
    SUCCESS: {
      TYPE: 'success',
      TITLE: 'Success',
    },
    ERROR: {
      TYPE: 'error',
      TITLE: 'Error',
      SOMETHING_WENT_WRONG:'Something went wrong.'
    },
    WARNING:{
      TYPE: 'warning',
      TITLE: 'Warning',
    }
  },
  REPORT_SECTION:{
    SECTION_NUMBER_REQUIRED:'Section number is required.',
    SECTION_REQUIRED:'Section is required.',
    SECTION_TITLE_REQUIRED:'Section title is required.'
  }
};